import React, { useState } from 'react'
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import ExternalAssistanceTable from './ExternalAssistanceTable';
import { AssistanceService } from '../../services/AssistanceService';
import Toast from "../../helpers/Toast";
import { InsertExternalHoursDTO } from '../../models/AditionalInfo/ValidExtraHourDTO';
import { AssistanceDTO } from '../../models/Assistance/AssistanceDTO';
import ValidExternalHours from './ValidExternalHours';
import { useAuth } from '../../context/AuthContext';


type AditionalInfoType = {
    assistanceId: number;
    reloadExecutions: boolean;
    mode: string;
    assistance: AssistanceDTO;
    isComplete: boolean
}

const AditionalInfo = ({ assistanceId, reloadExecutions, mode, assistance, isComplete }: AditionalInfoType) => {

    const intl = useIntl();
    const assistanceService = new AssistanceService();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>();
    const [klmValue, setKlmValue] = useState<number>(0);
    const [startTime, setStartTime] = useState<string>("");
    const [day, setDay] = useState<string>("")
    const [address, setAddress] = useState<string>("");
    const [reload, setReload] = useState<boolean>(false);
    const { isAdmin } = useAuth();


    const insertExtraHours = async () => {
        setIsButtonLoading(true);

        var data: InsertExternalHoursDTO = {
            assistanceId: assistanceId,
            travelHours: klmValue,
            date: day === "" || startTime === "" ? new Date("1900/01/01") : new Date(`${day}T${startTime}`),
        };

        var response = await assistanceService.InsertExternalHours(data);
        if (response.success === false) {
            setIsButtonLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
        setIsButtonLoading(false);
        setReload(!reload);
    }

    return (
        <div>
            <Row>
                <InputComponent xl={9} lg={9} md={9} sm={12} xs={12}
                    style={{ width: "100%"}}
                    type={"text"}
                    value={address}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.MoradaAssistencia" })}
                    readOnly={isComplete === false ? isLoading : true}
                    showLoadingSkeleton={isLoading}
                    onChange={(t: string) => {
                        setAddress(t);
                    }}
                />
            </Row>

            <Row style={{ marginBottom: "10px" }}>
                <InputComponent xl={2} lg={2} md={2} sm={12} xs={12}
                    style={{ width: "100%"}}
                    type={"number"}
                    value={klmValue}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.Distanciakm" })}
                    readOnly={isComplete === false ? isLoading : true}
                    showLoadingSkeleton={isLoading}
                    onChange={(t: number) => {
                        setKlmValue(t);
                    }}
                />
                <InputComponent xl={3} lg={3} md={3} sm={12} xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={day}
                    label={"Data"}
                    readOnly={isComplete === false ? isLoading : true}
                    showLoadingSkeleton={isLoading}
                    onChange={(t: string) => {
                        setDay(t)
                    }}
                />
                <InputComponent xl={2} lg={2} md={2} sm={12} xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={startTime}
                    label={intl.formatMessage({ id: "Screens.Assistances.AditionalInfo.Label.HoraInicio" })}
                    readOnly={isComplete === false ? isLoading : true}
                    showLoadingSkeleton={isLoading}
                    onChange={(t: string) => {
                        setStartTime(t);
                    }}
                />
                <Col xl={2} lg={2} md={2} sm={12} xs={12}>
                    <ButtonComponent
                        loading={isButtonLoading}
                        style={{ width: '100%', marginTop: '30px', padding: "8px" }}
                        text={intl.formatMessage({ id: "AditionalInfo.Insert" })}
                        onClick={() => insertExtraHours()}
                        disabled={isComplete}
                    />
                </Col>
            </Row>
            <Row>
                <ExternalAssistanceTable
                    assistanceId={assistanceId}
                    reload={reload}
                    isComplete={isComplete}
                />
            </Row>

            {
                isAdmin() === true ?
                    <Row>
                        <ValidExternalHours
                            assistanceId={assistanceId}
                            isComplete={isComplete}
                            setReload={setReload}
                            reload={reload} />
                    </Row> : ""
            }

        </div>
    )
}

export default AditionalInfo